import { render, staticRenderFns } from "./AppCheckbox.vue?vue&type=template&id=3ba39826&scoped=true"
import script from "./AppCheckbox.vue?vue&type=script&lang=js"
export * from "./AppCheckbox.vue?vue&type=script&lang=js"
import style0 from "./AppCheckbox.vue?vue&type=style&index=0&id=3ba39826&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba39826",
  null
  
)

export default component.exports